// extracted by mini-css-extract-plugin
export default {"container":"cD-z","dimension":"dD-z","dimensionLabels":"eD-z"};